<template>
  <div class="wrap">
    <div class="background" :class="{ disabled: $root.previewedProject }">
      <div class="rotating-image"></div>
    </div>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Background',
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  @transform-scale: scale(1.42);


  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: @z-layers[z-background];
    overflow: hidden;
    filter: brightness(100%);
    transition-property: filter;
    transition-duration: @transition-durations[main-block];
    transition-timing-function: @easing-functions[ease-out-cubic];

    &.disabled {
      filter: brightness(60%);
    }
  }

  .rotating-image {
    position: absolute;
    top: calc(50% - 50vw);
    left: 0;
    width: 100%;
    height: 100vw;
    filter: saturate(150%);

    background-image: url('../assets/images/background.svg');
    background-size: 100%;
    transform: @transform-scale rotate(0);

    animation-name: rotating-image-spin;
    animation-duration: 30s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    [prefers-reduced-motion] & {
      animation-name: unset;
    }

    @media @vertical {
      top: 0;
      left: calc(50% - 50vh);
      width: 100vh;
      height: 100vh;
    }
  }

  @keyframes rotating-image-spin {
    to {
      transform: @transform-scale rotate(1turn);
    }
  }

  .content {
    width: 100%;
    height: 100%;
    padding: @margins[background-padding];
    box-sizing: border-box;

    @media @vertical {
      padding: @margins-v[background-padding];
    }

    @media @mobile {
      padding: @margins-m[background-padding];
    }

    @media @mobile-vertical {
      padding: @margins-mv[background-padding];
    }
  }
</style>
